import {
  ContactService,
  DispositionService,
  VoiceControlService,
  VoiceService,
} from '@nice-devone/agent-sdk';
import { cxoneSdkState } from '../state';

export function getVoiceControlService(): VoiceControlService {
  if (!cxoneSdkState.voiceControlService) {
    cxoneSdkState.voiceControlService = new VoiceControlService();
  }
  return cxoneSdkState.voiceControlService;
}

export function getContactService(): ContactService {
  if (!cxoneSdkState.contactService) {
    cxoneSdkState.contactService = new ContactService();
  }
  return cxoneSdkState.contactService;
}

export function getVoiceService(): VoiceService {
  if (!cxoneSdkState.voiceService) {
    cxoneSdkState.voiceService = new VoiceService();
  }
  return cxoneSdkState.voiceService;
}

export function getDispositionService(): DispositionService {
  if (!cxoneSdkState.dispositionService) {
    cxoneSdkState.dispositionService = new DispositionService();
  }
  return cxoneSdkState.dispositionService;
}
